// extracted by mini-css-extract-plugin
module.exports = {"students":"Students_students__1q8Xl"};